import React from 'react';
import { string, node } from 'prop-types';

export const Bold = ({ children, className }) => <span className={`u__bold ${className}`}>{children}</span>;

Bold.displayname = 'Bold';

Bold.propTypes = {
  children: node,
  className: string,
};

Bold.defaultProps = {
  children: null,
  className: '',
};
